import { profile } from './store/profile/index';
import { User } from './store/profile/types';
import VueRouter from 'vue-router';
import { Vue, Component } from 'vue-property-decorator';
import store from './store';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave',
]);

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/privacy/', name: 'Privacy' },
        { path: '/terms/', name: 'Terms' },
        { path: '/canvas/', name: 'Canvas', meta: { requiresAuth: true } },
        { path: '/compass/', name: 'Compass', meta: { requiresAuth: true, disabled: true } },
        { path: '/connect/', name: 'Connect' },
        { path: '/profile/', name: 'Profile', meta: { requiresAuth: true }},
        { path: '/advisory/', name: 'Advisory', meta: { requiresAuth: true, disabled: true } },
        { path: '/thinking/', name: 'Thinking', meta: { requiresAuth: true, disabled: true } },
        { path: '/about/', name: 'About', meta: { requiresAuth: true, disabled: true } },
        { path: '/resetpassword/', name: 'ResetPassword' },
        { path: '/resetpassword/:resetid', name: 'ResetPasswordWithId' },
        { path: '/home', name: 'Home', meta: { requiresAuth: true, disabled: true } },
        { path: '/:pathMatch(.*)*', redirect: '/home', name: 'FallBack' },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!store.state.signedIn) {
        next({ name: 'Connect' });
      } else {
        next();
      }
    } else {
      next();
    }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.disabled)) {
    next(false);
  } else {
    next();
  }
});
